import * as w from "react";
import { g as z, c as T } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { s as D, u as I, c as O } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { u as V, r as $, h as S } from "./tss-DN0acMKN.mjs";
import { g as L } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as C } from "./jsx-runtime-3tyXYecC.mjs";
import { e as U } from "./extendSxProp-BhQEuuTD.mjs";
const N = /* @__PURE__ */ w.createContext();
function Z(n) {
  return z("MuiGrid", n);
}
const A = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F = ["column-reverse", "column", "row-reverse", "row"], K = ["nowrap", "wrap-reverse", "wrap"], m = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], g = L("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...A.map((n) => `spacing-xs-${n}`),
  // direction values
  ...F.map((n) => `direction-xs-${n}`),
  // wrap values
  ...K.map((n) => `wrap-xs-${n}`),
  // grid sizes for all breakpoints
  ...m.map((n) => `grid-xs-${n}`),
  ...m.map((n) => `grid-sm-${n}`),
  ...m.map((n) => `grid-md-${n}`),
  ...m.map((n) => `grid-lg-${n}`),
  ...m.map((n) => `grid-xl-${n}`)
]);
function _({
  theme: n,
  ownerState: r
}) {
  let i;
  return n.breakpoints.keys.reduce((t, e) => {
    let s = {};
    if (r[e] && (i = r[e]), !i)
      return t;
    if (i === !0)
      s = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (i === "auto")
      s = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const o = $({
        values: r.columns,
        breakpoints: n.breakpoints.values
      }), c = typeof o == "object" ? o[e] : o;
      if (c == null)
        return t;
      const u = `${Math.round(i / c * 1e8) / 1e6}%`;
      let a = {};
      if (r.container && r.item && r.columnSpacing !== 0) {
        const l = n.spacing(r.columnSpacing);
        if (l !== "0px") {
          const p = `calc(${u} + ${l})`;
          a = {
            flexBasis: p,
            maxWidth: p
          };
        }
      }
      s = {
        flexBasis: u,
        flexGrow: 0,
        maxWidth: u,
        ...a
      };
    }
    return n.breakpoints.values[e] === 0 ? Object.assign(t, s) : t[n.breakpoints.up(e)] = s, t;
  }, {});
}
function q({
  theme: n,
  ownerState: r
}) {
  const i = $({
    values: r.direction,
    breakpoints: n.breakpoints.values
  });
  return S({
    theme: n
  }, i, (t) => {
    const e = {
      flexDirection: t
    };
    return t.startsWith("column") && (e[`& > .${g.item}`] = {
      maxWidth: "none"
    }), e;
  });
}
function y({
  breakpoints: n,
  values: r
}) {
  let i = "";
  Object.keys(r).forEach((e) => {
    i === "" && r[e] !== 0 && (i = e);
  });
  const t = Object.keys(n).sort((e, s) => n[e] - n[s]);
  return t.slice(0, t.indexOf(i));
}
function H({
  theme: n,
  ownerState: r
}) {
  const {
    container: i,
    rowSpacing: t
  } = r;
  let e = {};
  if (i && t !== 0) {
    const s = $({
      values: t,
      breakpoints: n.breakpoints.values
    });
    let o;
    typeof s == "object" && (o = y({
      breakpoints: n.breakpoints.values,
      values: s
    })), e = S({
      theme: n
    }, s, (c, u) => {
      const a = n.spacing(c);
      return a !== "0px" ? {
        marginTop: n.spacing(-c),
        [`& > .${g.item}`]: {
          paddingTop: a
        }
      } : o != null && o.includes(u) ? {} : {
        marginTop: 0,
        [`& > .${g.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return e;
}
function J({
  theme: n,
  ownerState: r
}) {
  const {
    container: i,
    columnSpacing: t
  } = r;
  let e = {};
  if (i && t !== 0) {
    const s = $({
      values: t,
      breakpoints: n.breakpoints.values
    });
    let o;
    typeof s == "object" && (o = y({
      breakpoints: n.breakpoints.values,
      values: s
    })), e = S({
      theme: n
    }, s, (c, u) => {
      const a = n.spacing(c);
      if (a !== "0px") {
        const l = n.spacing(-c);
        return {
          width: `calc(100% + ${a})`,
          marginLeft: l,
          [`& > .${g.item}`]: {
            paddingLeft: a
          }
        };
      }
      return o != null && o.includes(u) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${g.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return e;
}
function Q(n, r, i = {}) {
  if (!n || n <= 0)
    return [];
  if (typeof n == "string" && !Number.isNaN(Number(n)) || typeof n == "number")
    return [i[`spacing-xs-${String(n)}`]];
  const t = [];
  return r.forEach((e) => {
    const s = n[e];
    Number(s) > 0 && t.push(i[`spacing-${e}-${String(s)}`]);
  }), t;
}
const X = D("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (n, r) => {
    const {
      ownerState: i
    } = n, {
      container: t,
      direction: e,
      item: s,
      spacing: o,
      wrap: c,
      zeroMinWidth: u,
      breakpoints: a
    } = i;
    let l = [];
    t && (l = Q(o, a, r));
    const p = [];
    return a.forEach((f) => {
      const d = i[f];
      d && p.push(r[`grid-${f}-${String(d)}`]);
    }), [r.root, t && r.container, s && r.item, u && r.zeroMinWidth, ...l, e !== "row" && r[`direction-xs-${String(e)}`], c !== "wrap" && r[`wrap-xs-${String(c)}`], ...p];
  }
})(
  // FIXME(romgrk): Can't use memoTheme here
  ({
    ownerState: n
  }) => ({
    boxSizing: "border-box",
    ...n.container && {
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    ...n.item && {
      margin: 0
      // For instance, it's useful when used with a `figure` element.
    },
    ...n.zeroMinWidth && {
      minWidth: 0
    },
    ...n.wrap !== "wrap" && {
      flexWrap: n.wrap
    }
  }),
  q,
  H,
  J,
  _
);
function Y(n, r) {
  if (!n || n <= 0)
    return [];
  if (typeof n == "string" && !Number.isNaN(Number(n)) || typeof n == "number")
    return [`spacing-xs-${String(n)}`];
  const i = [];
  return r.forEach((t) => {
    const e = n[t];
    if (Number(e) > 0) {
      const s = `spacing-${t}-${String(e)}`;
      i.push(s);
    }
  }), i;
}
const nn = (n) => {
  const {
    classes: r,
    container: i,
    direction: t,
    item: e,
    spacing: s,
    wrap: o,
    zeroMinWidth: c,
    breakpoints: u
  } = n;
  let a = [];
  i && (a = Y(s, u));
  const l = [];
  u.forEach((f) => {
    const d = n[f];
    d && l.push(`grid-${f}-${String(d)}`);
  });
  const p = {
    root: ["root", i && "container", e && "item", c && "zeroMinWidth", ...a, t !== "row" && `direction-xs-${String(t)}`, o !== "wrap" && `wrap-xs-${String(o)}`, ...l]
  };
  return O(p, Z, r);
}, cn = /* @__PURE__ */ w.forwardRef(function(r, i) {
  const t = I({
    props: r,
    name: "MuiGrid"
  }), {
    breakpoints: e
  } = V(), s = U(t), {
    className: o,
    columns: c,
    columnSpacing: u,
    component: a = "div",
    container: l = !1,
    direction: p = "row",
    item: f = !1,
    rowSpacing: d,
    spacing: h = 0,
    wrap: M = "wrap",
    zeroMinWidth: j = !1,
    ...v
  } = s, R = d || h, E = u || h, P = w.useContext(N), b = l ? c || 12 : P, G = {}, W = {
    ...v
  };
  e.keys.forEach((x) => {
    v[x] != null && (G[x] = v[x], delete W[x]);
  });
  const k = {
    ...s,
    columns: b,
    container: l,
    direction: p,
    item: f,
    rowSpacing: R,
    columnSpacing: E,
    wrap: M,
    zeroMinWidth: j,
    spacing: h,
    ...G,
    breakpoints: e.keys
  }, B = nn(k);
  return /* @__PURE__ */ C.jsx(N.Provider, {
    value: b,
    children: /* @__PURE__ */ C.jsx(X, {
      ownerState: k,
      className: T(B.root, o),
      as: a,
      ref: i,
      ...W
    })
  });
});
export {
  cn as G
};
//# sourceMappingURL=Grid-YOVcEbCu.mjs.map
